import React from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

/**
 * A table header cell with a sort toggle. The icon shows the current state:
 * both arrows when unsorted, one arrow for ascending or descending.
 *
 * @param {Object} props
 * @param {string} props.label Header text
 * @param {string} props.field The API's sort_by value for this column
 * @param {{field: string|null, dir: "asc"|"desc"|null}} props.sort Current sort
 * @param {(field: string) => void} props.onSort Called with `field` on click
 * @returns {JSX.Element}
 */
export function SortableHeader({ label, field, sort, onSort }) {
  const active = sort?.field === field;
  const Icon = !active ? UnfoldMoreIcon : sort.dir === "asc" ? ArrowUpwardIcon : ArrowDownwardIcon;
  const state = !active ? "not sorted" : sort.dir === "asc" ? "sorted A to Z" : "sorted Z to A";

  return (
    <th aria-sort={!active ? "none" : sort.dir === "asc" ? "ascending" : "descending"}>
      <button
        type="button"
        onClick={() => onSort(field)}
        title={`Sort by ${label} (${state})`}
        className="d-inline-flex align-items-center p-0 border-0 bg-transparent"
        style={{ font: "inherit", color: "inherit", cursor: "pointer", gap: 4 }}
      >
        {label}
        <Icon style={{ fontSize: 16, opacity: active ? 1 : 0.4 }} />
      </button>
    </th>
  );
}
